<template>
  <div class="contentPadding">
    <a-form layout="inline" :model="listQuery" style="margin-bottom:20px;">
      <a-form-item label="用户名">
        <a-input
          placeholder="请输入"
          v-model:value="listQuery.userName"
          allowClear
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearch"> 查询 </a-button>
      </a-form-item>
      
      <a-form-item>
        <a-button @click="handleAllReset"> 重置 </a-button>
      </a-form-item>
    </a-form>
    <a-row class="buttonGroup">
        <a-button
          type="primary"
          @click="handleAdd"
          v-if="isShowBtn('sys:user:save')"
          ><PlusOutlined /> 新增
        </a-button>
      </a-row>
    <a-table
      :row-selection="rowSelection"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      row-key="userId"
      @change="changeTable"
    >
      <a-table-column key="loginName" title="ID" data-index="loginName">
        <template v-slot="scope">
          {{
            (Number(pagination.current) - 1) * Number(pagination.pageSize) +
              scope.index +
              1
          }}
        </template>
      </a-table-column>
      <a-table-column key="loginName" title="登陆账号" data-index="loginName" />
      <a-table-column key="userName" title="用户名" data-index="userName" />
      <a-table-column key="email" title="邮箱" data-index="email" />
      <a-table-column key="mobile" title="手机号" data-index="mobile" />
      <a-table-column key="status" title="状态" data-index="status">
        <template v-slot="scope">
          <span v-if="scope.record.status === 1">正常</span>
          <span v-else>禁用</span>
        </template>
      </a-table-column>
      <a-table-column
        key="createTime"
        title="创建时间"
        data-index="createTime"
      />
      <a-table-column key="action" title="操作">
        <template v-slot="scope">
          <span>
            <a-button
              type="link"
              @click="handleShow(scope.record)"
              v-if="isShowBtn('sys:user:info')"
            >
              查看
            </a-button>
            <a-button
              type="link"
              @click="handleEdit(scope.record)"
              v-if="isShowBtn('sys:user:update')"
            >
              修改
            </a-button>
            <a-button
              type="link"
              @click="handleDel(scope.record)"
              v-if="isShowBtn('sys:user:delete')"
            >
              删除
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <!-- 添加、修改modal -->
    <a-modal
      :title="title"
      v-model:visible="showModal"
      :maskClosable="false"
      :footer="null"
      :centered="true"
      width="40%"
    >
      <a-form
        :labelCol="{ span: 3, offset: 0 }"
        :wrapperCol="{ span: 20, offset: 0 }"
        ref="addForm"
        :model="userInfo"
        :rules="rules"
      >
        <a-form-item label="登陆名" name="loginName">
          <a-input v-model:value="userInfo.loginName" :disabled="isShow" />
        </a-form-item>
        <a-form-item label="用户名" name="userName">
          <a-input v-model:value="userInfo.userName" :disabled="isShow" />
        </a-form-item>
        <a-form-item label="密码" name="pass" v-if="!isShow">
          <a-input v-model:value="userInfo.pass" type="password" />
        </a-form-item>
        <a-form-item label="确认密码" name="ispass" v-if="!isShow">
          <a-input v-model:value="userInfo.ispass" type="password" />
        </a-form-item>
        <a-form-item label="邮箱" name="email">
          <a-input v-model:value="userInfo.email" :disabled="isShow" />
        </a-form-item>
        <a-form-item label="手机号" name="mobile">
          <a-input v-model:value="userInfo.mobile" :disabled="isShow" />
        </a-form-item>
        <a-form-item label="角色">
          <a-checkbox-group
            v-model:value="userInfo.roleIdList"
            :disabled="isShow"
          >
            <a-checkbox
              v-for="item in roleList"
              :key="item.roleId"
              :value="item.roleId"
              name="type"
            >
              {{ item.roleName }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="状态">
          <a-radio-group v-model:value="userInfo.status" :disabled="isShow">
            <a-radio value="0">
              禁用
            </a-radio>
            <a-radio value="1">
              正常
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 9 }">
          <a-button type="primary" @click="handleSave" v-if="!isShow">
            保存
          </a-button>
          <a-button
            style="margin-left: 10px;"
            @click="handleCancle"
            v-if="!isShow"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="handleCancle"
            v-if="isShow"
          >
            关闭
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { PlusOutlined } from "@ant-design/icons-vue";
import {
  ExclamationCircleOutlined
} from "@ant-design/icons-vue";
import { createVNode } from "vue";
import { Modal, notification } from "ant-design-vue";
import { isShowBtn } from "../../../until/tool";
export default {
  data() {
    const validatepass = async (rule, value) => {
      const pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,18}');
      if (value === "") {
        return Promise.reject("请输入密码");
      } else if (!pwdRegex.test(value)) {
        return Promise.reject("密码复杂度太低（密码中必须包含字母、数字、特殊字符,长度为6-18位），请重新设置密码！");
      } else {
        if (this.userInfo.ispass !== "") {
          this.$refs.addForm.validateField("ispass");
        }
        return Promise.resolve();
      }
    };
    const validateIspass = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入确认密码");
      } else if (value !== this.userInfo.pass) {
        return Promise.reject("确认密码与密码不一致");
      } else {
        return Promise.resolve();
      }
    };
    const validateEmail = async (rule, value) => {
      const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (value === "") {
        return Promise.reject("请输入邮箱");
      } else if (!reg.test(value)) {
        return Promise.reject("邮箱格式不正确");
      } else {
        return Promise.resolve();
      }
    };
    const validateMobile = async (rule, value) => {
      const reg = /^1[3|4|5|7|8][0-9]\d{4,8}$/;
      if (value === "") {
        return Promise.reject("请输入手机号");
      } else if (!reg.test(value)) {
        return Promise.reject("手机号格式不正确");
      } else {
        return Promise.resolve();
      }
    };
    return {
      title: "",
      rules: {
        loginName: [
          { required: true, message: "请输入登陆名", trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        pass: [{ required: true, validator: validatepass, trigger: "change" }],
        ispass: [{ validator: validateIspass, trigger: "change" }],
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        mobile: [{ required: true, validator: validateMobile, trigger: "blur" }]
      },
      showModal: false, //添加、修改modal的flag
      listQuery: {
        pageSize: 10,
        pageIndex: 1,
        userName: ""
      },
      userInfo: {
        id: "",
        loginName: "",
        userName: "",
        pass: "",
        ispass: "",
        email: "",
        mobile: "",
        roleIdList: [],
        status: "2"
      }, //管理员信息对象
      roleList: [], //角色列表
      data: [], //列表数据
      loading: false,
      selectRowIds: "", //被选中都行
      isShow: false, //是否查看
      pagination: {
        // 分页配置器
        pageSize: 10, // 一页的数据限制
        current: 1, // 当前页
        total: 0, // 总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变 pageSize
        pageSizeOptions: ["5", "10", "30"] // 指定每页可以显示多少条
        // onShowSizeChange: (current, pagesize) => { // 改变 pageSize时的回调
        //   this.pagination.current = current
        //   this.pagination.pageSize = pagesize
        //   ....
        // },
        // onChange: (current) => { // 切换分页时的回调，
        // 当在页面定义change事件时，切记要把此处的事件清除，因为这两个事件重叠了，可能到时候会导致一些莫名的bug
        //   this.pagination.current = current
        // },
        // showTotal: total => `总数：${total}人` // 可以展示总数
      }
    };
  },
  created() {
    this.getRoleList();
  },
  mounted() {
    this.getList();
  },
  computed: {
    // 判断选择了哪行数据
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRowIds = selectedRowKeys;
        }
      };
    }
  },
  methods: {
    // 判断按钮权限
    isShowBtn,
    //情况添加数据
    temp() {
      this.userInfo = {
        id: "",
        loginName: "",
        userName: "",
        pass: "",
        ispass: "",
        email: "",
        mobile: "",
        roleIdList: [],
        status: "2"
      };
    },
    // 获取所有角色列表
    getRoleList() {
      this.$store
        .dispatch("SelecRoletList")
        .then(res => {
          if (res.code === 0) {
            this.roleList = res.data;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 新增
    handleAdd() {
      this.title = "新增管理员信息";
      this.isShow = false;
      this.showModal = true;
      this.temp();
    },
    // 取消
    handleCancle() {
      this.showModal = false;
      this.$refs.addForm.resetFields();
      this.temp();
    },
    // 保存用户信息
    handleSave() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const userObj = Object.assign(self.userInfo);
      userObj.password = userObj.pass;
      let funStr = "";
      let msg = "";
      if (userObj.id === "") {
        funStr = "SaveUser";
        msg = "添加成功";
      } else {
        funStr = "UpdateUser";
        msg = "修改成功";
      }
      this.$refs.addForm
        .validate()
        .then(() => {
          self.$store
            .dispatch(funStr, self.userInfo)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: msg
                });
                this.showModal = false;
                this.temp();
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        })
        .catch(error => {
          return false;
        });
    },
    // 查看
    handleShow(rowData) {
      this.title = "管理员信息";
      this.isShow = true;
      this.showModal = true;
      this.$store
        .dispatch("SelectUserById", { userId: rowData.userId })
        .then(res => {
          if (res.code === 0) {
            let obj = {};
            obj = Object.assign({}, res.user);
            obj.status = res.user.status + "";
            obj.roleIdList = res.user.roleIdList;
            this.userInfo = obj;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 修改
    handleEdit(rowData) {
      this.title = "修改管理员信息";
      this.isShow = false;
      this.showModal = true;
      this.$store
        .dispatch("SelectUserById", { userId: rowData.userId })
        .then(res => {
          if (res.code === 0) {
            let obj = {};
            obj = Object.assign({}, res.user);
            obj.status = res.user.status + "";
            obj.roleIdList = res.user.roleIdList;
            this.userInfo = obj;
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 查询
    handleSearch() {
      this.listQuery.pageIndex = "1";
      this.listQuery.pageSize = this.pagination.pageSize;
      this.getList();
    },
    handleAllReset(){
      this.listQuery = {
        pageSize: 10,
        pageIndex: 1,
        userName: ""
      }
    },
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("SelectUserList", this.listQuery)
        .then(res => {
          if (res.code === 0) {
            if (
              res.page.currPage > res.page.totalPage &&
              res.page.totalPage !== 0
            ) {
              this.listQuery.pageIndex = res.page.totalPage;
              this.getList();
            } else {
              this.listQuery.pageIndex = res.page.currPage;
            }
            this.data = res.page.list;
            this.listQuery.pageSize = res.page.pageSize;
            this.pagination.current = res.page.currPage;
            this.pagination.pageSize = res.page.pageSize;
            this.pagination.total = res.page.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            // this.$message.error(res.msg);
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 删除
    handleDel(rowData) {
      this.$store
        .dispatch("DeleteUserById", rowData.userId)
        .then(res => {
          if (res.code === 0) {
            notification["success"]({
              message: "删除成功"
            });
            this.getList();
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 删除多条数据
    handleAllDel() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      if (this.selectRowIds.length === 0) {
        this.$message.warning("请先选择数据，在进行批量删除操作");
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认批量删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self.$store
            .dispatch("DeleteUserBatchById", self.selectRowIds.join(","))
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.selectRowIds = "";
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        },
        onCancel() {
        }
      });
    },
    // 分页、排序、筛选变化时触发
    changeTable(pagination, filters, sorter) {
      this.listQuery.pageIndex = pagination.current;
      this.listQuery.pageSize = pagination.pageSize;
      this.getList();
    }
  }
};
</script>
<style scoped></style>
